export default "/_nuxt/6ff52f1f6fb4c80724a9bc80849794e1.svg";